export { default } from "./SignUpCta";
